import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getproductvacs: option =>
    request('v1/vacconfig/getproductvacs', option, true, false), // 查询增值业务列表
  getvacconfigs: option =>
    request('v1/vacconfig/getvacconfigs', option, true, false), // 查询增值业务,
  updatevacconfig: option =>
    request('v1/vacconfig/updatevacconfig', option, true, false), // 修改增值业务配置项
  getvaclibs: option => request('v1/vaclib/getvaclibs', option, true, false), // 查询增值业务素材列表
  getvaclib: option => {
    const urls = querystring(option)
    return request('v1/vaclib/getvaclib' + urls, option, true, false) // 查询增值业务素材,
  },
  addvaclib: option => request('v1/vaclib/addvaclib', option, true, false), // 新增增值业务素材
  deletevaclib: option => {
    const urls = querystring(option)
    return request('v1/vaclib/deletevaclib' + urls, option, true, false) // 删除增值业务素材,
  },
  updatevaclib: option =>
    request('v1/vaclib/updatevaclib', option, true, false), // 修改增值业务素材
  copyvaclib: option => {
    const urls = querystring(option)
    return request('v1/vaclib/copyvaclib' + urls, {}, true, false) //  复制增值业务素材
  },
  savetovaclib: option => request('v1/vaclib/savetovaclib', option, true, false) // 保存到增值业务素材库,
}
